<template>
  <section>
    <div
      class="row">
      <div class="col">
        <form-wizard
          id="wizard"
          :ref="'wizard'"
          :hide-buttons="renderContractLoading"
          title=""
          subtitle=""
          color="rgb(0, 68, 95)"
          step-size="xs"
          @on-change="handleTabChange">
          <template #title />
          <template>
            <tab-content :title="$t('message.serialLetterProcess.defineLetterContent')">
              <div
                v-if="renderContractLoading"
                class="text-center">
                <coozzy-spinner />
              </div>
              <div v-else>
                <div class="row">
                  <div class="col-6">
                    <h2>{{ $t('message.serialLetterProcess.defineLetterContent') }}</h2>
                    <p>{{ $t('message.serialLetterProcess.defineLetterContentHeadline') }}</p>
                    <div class="row">
                      <div class="col-12 mb-1">
                        <label>{{ $t('message.settings.template.textTemplate') }}</label>
                        <coozzy-form-select
                          v-model="selectedTemplate"
                          name="numberEntries">
                          <option
                            value="">
                            -
                          </option>
                          <option
                            v-for="template in sortedTemplate"
                            :key="template.id"
                            :value="template.id">
                            {{ template.name }}
                          </option>
                        </coozzy-form-select>
                      </div>
                      <div class="col-12 mb-1">
                        <label>{{ $t('message.serialLetterProcess.subject') }}</label>
                        <coozzy-form-input
                          id="title"
                          v-model="title" />
                      </div>
                      <div class="col-12 mb-2">
                        <label>{{ $t('message.serialLetterProcess.letterText') }}</label>
                        <editor
                          ref="editor-tiny"
                          v-model="description"
                          :api-key="editorApi"
                          :init="{
                            toolbar: 'undo redo | bold italic underline forecolor | numlist bullist',
                            plugins: 'fullscreen lists code image table link',
                            height: '370',
                            menubar: '',
                            language: currentLanguage,
                            elementpath: false,
                            automatic_uploads: true,
                            license_key: 'gpl',
                            content_style: contentStyle,
                            font_formats: fontFormats,
                            branding: false,
                            remove_trailing_brs: false,
                            browser_spellcheck: true,
                            table_toolbar: '',
                            font_size_formats: fontsizeFormats,
                            setup(editor) {
                              editor.on('NodeChange', () => {
                                // When user changes something, ensure the correct color is applied
                                const selection = editor.selection.getNode()
                                const currentColor = editor.dom.getStyle(selection, 'color')

                                // If the user hasn't changed the color, it will stay black
                                if (!currentColor) {
                                  editor.dom.setStyle(selection, 'color', 'black')
                                }
                              })
                            }
                          }" />
                      </div>
                    </div>
                  </div>
                  <div class="col-6 container-preview-img">
                    <img
                      alt="preview-pdf"
                      class="w-100"
                      src="/preview-pdf.jpg">
                  </div>
                </div>
              </div>
            </tab-content>
            <tab-content :title="$t('message.serialLetterProcess.chooseTemplate')">
              <div
                v-if="renderContractLoading"
                class="text-center">
                <coozzy-spinner />
              </div>
              <div v-else>
                <h2>{{ $t('message.serialLetterProcess.chooseTemplate') }}</h2>
                <template-table
                  :default-category="'TEMPLATE_CATEGORY_LETTER'"
                  :render-contract-loading="renderContractLoading"
                  :source="'objectTenancy'"
                  :by-owners-ids="templateOwnersIds"
                  @contracts-loaded="contractsLoaded"
                  @selected-contract="itemSelected" />
              </div>
            </tab-content>
            <tab-content
              :title="listOfReferenceIds.length === 1 ? $tc('message.generic.oneSerialLetter') : $tc('message.generic.serialLetter')">
              <div
                v-if="renderContractLoading"
                class="text-center">
                <coozzy-spinner />
              </div>
              <div v-else>
                <div class="step3">
                  <div class="row">
                    <div class="col-6">
                      <template
                        v-if="listOfReferenceIds.length === 1">
                        <div>
                          <div class="row">
                            <div class="col-12">
                              <label
                                v-if="source === 'contact'"
                                for="question1">{{
                                  $t('message.serialLetterProcess.step3.documentAssignedToOneContact')
                                }}</label>
                              <label
                                v-else
                                for="question1">{{
                                  $t('message.serialLetterProcess.step3.documentAssignedToOneTenancy')
                                }}</label>
                              <div class="row mt-2">
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="addDocumentToContact"
                                    :disabled="mergeDocuments"
                                    :select-value="true"
                                    class="p-0 btn likeBtn"
                                    name="addDocumentToContact">
                                    {{ $t('message.generic.selectField.yes') }}
                                  </coozzy-form-radio>
                                </div>
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="addDocumentToContact"
                                    :disabled="mergeDocuments"
                                    :select-value="false"
                                    class="p-0 btn likeBtn"
                                    name="addDocumentToContact">
                                    {{ $t('message.generic.selectField.no') }}
                                  </coozzy-form-radio>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="$store.getters['user/isEditor'] && $store.getters['user/hasDocumentsPortal'] && addDocumentToContact"
                              class="col-12">
                              <label
                                for="questionPortal">
                                {{ $t('message.serialLetterProcess.step3.showDocumentInPortal') }}
                                <coozzy-info-circle-icon
                                  v-if="isAllPortalLinkDisable"
                                  v-b-tooltip.hover.html="$t('message.manageDocuments.tooltipShowInPortal')" />
                                <coozzy-info-circle-icon
                                  v-else-if="!allPortalLinkEnabled"
                                  v-b-tooltip.hover.html="$t('message.serialLetterProcess.step3.showDocumentInPortalTooltip')" />
                              </label>
                              <div class="row mt-2">
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="showInPortal"
                                    :default-model="showInPortal"
                                    :select-value="true"
                                    class="p-0 btn likeBtn"
                                    name="showInPortal">
                                    {{ $t('message.generic.selectField.yes') }}
                                  </coozzy-form-radio>
                                </div>
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="showInPortal"
                                    :default-model="showInPortal"
                                    :select-value="false"
                                    class="p-0 btn likeBtn"
                                    name="showInPortal">
                                    {{ $t('message.generic.selectField.no') }}
                                  </coozzy-form-radio>
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="activeTab === 2"
                              class="col-12">
                              <label
                                for="questiondocumentNamed">
                                {{ $t('message.serialLetterProcess.step3.documentNamed') }}
                              </label>
                              <template v-for="item in onlySelectedTemplate">
                                <div
                                  :key="item.id"
                                  class="row mt-2">
                                  <div class="col-3 title-center">
                                    {{ item.title }}
                                  </div>
                                  <div class="col-4">
                                    <coozzy-form-input
                                      v-model="item.documentName"
                                      :name="$t('message.serialLetterProcess.step3.documentName')"
                                      @change="randomKey++" />
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </template>
                      <template
                        v-else>
                        <div>
                          <div class="row mb-3">
                            <div class="col-12">
                              <label for="question1">{{
                                $t('message.serialLetterProcess.step3.createCollectionDocument')
                              }}</label>
                              <div class="row mt-2">
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="mergeDocuments"
                                    :select-value="true"
                                    class="p-0 btn likeBtn"
                                    name="mergeDocuments">
                                    {{ $t('message.generic.selectField.yes') }}
                                  </coozzy-form-radio>
                                </div>
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="mergeDocuments"
                                    :select-value="false"
                                    class="p-0 btn likeBtn"
                                    name="mergeDocuments">
                                    {{ $t('message.generic.selectField.no') }}
                                  </coozzy-form-radio>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div
                              v-if="mergeDocuments && contractTemplateSelected.length > 1"
                              class="col">
                              <p>
                                {{
                                  $t('message.serialLetterProcess.step3.numberOfDocumentsGenerated', {
                                    x:
                                      contractTemplateSelected.length
                                  })
                                }}
                              </p>
                            </div>
                            <div
                              v-else-if="mergeDocuments && contractTemplateSelected.length === 1"
                              class="col">
                              <p>{{ $t('message.serialLetterProcess.step3.oneDocumentIsCreated') }}</p>
                            </div>
                            <div
                              v-else-if="!mergeDocuments"
                              class="col">
                              <p v-if="source === 'contact'">
                                {{
                                  $t('message.serialLetterProcess.step3.numberOfDocumentsGenerated', {
                                    x:
                                      (contractTemplateSelected.length * contacts.length)
                                  })
                                }}
                              </p>
                              <p v-else>
                                {{
                                  $t('message.serialLetterProcess.step3.numberOfDocumentsGenerated', {
                                    x:
                                      (contractTemplateSelected.length * countGeneratedDocs)
                                  })
                                }}
                              </p>
                            </div>
                          </div>
                          <div class="row mb-3">
                            <div class="col-12">
                              <label
                                v-if="source === 'contact'"
                                for="question22">
                                {{ $t('message.serialLetterProcess.step3.documentAssignedToContacts') }}
                              </label>
                              <label
                                v-else
                                for="question2">
                                {{ $t('message.serialLetterProcess.step3.documentAssignedToTenancies') }}
                                <!--                            <coozzy-info-circle-icon-->
                                <!--                              v-if="mergeDocuments"-->
                                <!--                              v-b-tooltip.hover.html="$t('message.serialLetterProcess.step3.documentAssignedToTenanciesTooltip')" />-->
                              </label>
                              <div class="row mt-2">
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="addDocumentToContact"
                                    :default-model="addDocumentToContact"
                                    :select-value="true"
                                    class="p-0 btn likeBtn"
                                    name="addDocumentToContact">
                                    {{ $t('message.generic.selectField.yes') }}
                                  </coozzy-form-radio>
                                </div>
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="addDocumentToContact"
                                    :default-model="addDocumentToContact"
                                    :select-value="false"
                                    class="p-0 btn likeBtn"
                                    name="addDocumentToContact">
                                    {{ $t('message.generic.selectField.no') }}
                                  </coozzy-form-radio>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="$store.getters['user/isEditor'] && $store.getters['user/hasDocumentsPortal'] && addDocumentToContact"
                              class="col-12">
                              <label
                                for="questionPortal">
                                {{ $t('message.serialLetterProcess.step3.showDocumentInPortal') }}
                                <coozzy-info-circle-icon
                                  v-if="isAllPortalLinkDisable"
                                  v-b-tooltip.hover.html="$t('message.manageDocuments.tooltipShowInPortal')" />
                                <coozzy-info-circle-icon
                                  v-else-if="!allPortalLinkEnabled"
                                  v-b-tooltip.hover.html="$t('message.serialLetterProcess.step3.showDocumentInPortalTooltip')" />
                              </label>
                              <div class="row mt-2">
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="showInPortal"
                                    :default-model="showInPortal"
                                    :select-value="true"
                                    class="p-0 btn likeBtn"
                                    name="showInPortal">
                                    {{ $t('message.generic.selectField.yes') }}
                                  </coozzy-form-radio>
                                </div>
                                <div class="col-2">
                                  <coozzy-form-radio
                                    v-model="showInPortal"
                                    :default-model="showInPortal"
                                    :select-value="false"
                                    class="p-0 btn likeBtn"
                                    name="showInPortal">
                                    {{ $t('message.generic.selectField.no') }}
                                  </coozzy-form-radio>
                                </div>
                              </div>
                            </div>
                            <div
                              v-if="activeTab === 2"
                              class="col-12">
                              <label
                                for="questiondocumentNamed">
                                {{ $t('message.serialLetterProcess.step3.documentNamed') }}
                              </label>
                              <template v-for="item in onlySelectedTemplate">
                                <div
                                  :key="item.id"
                                  class="row mt-2">
                                  <div class="col-3 title-center">
                                    {{ item.title }}
                                  </div>
                                  <div class="col-4">
                                    <coozzy-form-input
                                      v-model="item.documentName"
                                      :name="$t('message.serialLetterProcess.step3.documentName')"
                                      @change="randomKey++" />
                                  </div>
                                </div>
                              </template>
                            </div>
                          </div>
                        </div>
                      </template>
                      <div>
                        <div
                          v-if="source === 'condominium'"
                          class="row mb-3">
                          <div class="col-12">
                            <label for="question2">{{ $t('message.serialLetterProcess.step3.includeRoommate') }}
                            </label>
                            <div class="row mt-2">
                              <div class="col-2">
                                <coozzy-form-radio
                                  v-model="includeRoommates"
                                  :default-model="includeRoommates"
                                  :select-value="true"
                                  class="p-0 btn likeBtn"
                                  name="includeRoommates">
                                  {{ $t('message.generic.selectField.yes') }}
                                </coozzy-form-radio>
                              </div>
                              <div class="col-2">
                                <coozzy-form-radio
                                  v-model="includeRoommates"
                                  :default-model="includeRoommates"
                                  :select-value="false"
                                  class="p-0 btn likeBtn"
                                  name="includeRoommates">
                                  {{ $t('message.generic.selectField.no') }}
                                </coozzy-form-radio>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--        Sorting          -->
                      <div
                        v-if="mergeDocuments">
                        <div
                          :id="`collapse-sorting`"
                          v-b-toggle="`collapse-sorting`"
                          class="pt-3 mb-0">
                          <h5
                            class="cursor-pointer hover width-only-content">
                            {{ $t('message.serialLetterProcess.step3.sorting.title') }}
                          </h5>
                        </div>
                        <b-collapse
                          :id="`collapse-sorting`"
                          ref="collapse"
                          :visible="true"
                          class="">
                          <div class="row details-row-bg-1 py-01rem pr-3">
                            <div class="col-sm-12 col-md-6">
                              <label>{{ $t('message.serialLetterProcess.step3.sorting.desiredSortingLetter') }}</label>
                              <coozzy-form-select
                                v-model="sortingType"
                                class="mb-2">
                                <option :value="'RENDER_ORDER_DEFAULT'">
                                  {{ $t('message.serialLetterProcess.step3.sorting.sortPropbaseStandard') }}
                                </option>
                                <option :value="'RENDER_ORDER_NUMERIC_ID'">
                                  {{ $t('message.serialLetterProcess.step3.sorting.sortByAddressNumber') }}
                                </option>
                                <option :value="'RENDER_ORDER_OBJECT_NUMBER_ASC'">
                                  {{ $t('message.serialLetterProcess.step3.sorting.sortByObjectNbrAsc') }}
                                </option>
                                <option :value="'RENDER_ORDER_OBJECT_NUMBER_DESC'">
                                  {{ $t('message.serialLetterProcess.step3.sorting.sortByObjectNbrDesc') }}
                                </option>
                              </coozzy-form-select>
                            </div>
                          </div>
                        </b-collapse>
                      </div>
                      <div
                        v-if="$store.getters['user/getIsBriefButlerEnabled']"
                        class="row mb-3">
                        <div class="col-12">
                          <label for="question2">{{ $t('message.serialLetterProcess.step3.sendToBriefbutler') }}
                          </label>
                          <div class="row mt-2">
                            <div class="col-2">
                              <coozzy-form-radio
                                v-model="sendToBriefbutler"
                                :default-model="sendToBriefbutler"
                                name="sendToBriefbutler"
                                class="p-0 btn likeBtn"
                                :select-value="true">
                                {{ $t('message.generic.selectField.yes') }}
                              </coozzy-form-radio>
                            </div>
                            <div class="col-2">
                              <coozzy-form-radio
                                v-model="sendToBriefbutler"
                                :default-model="sendToBriefbutler"
                                name="sendToBriefbutler"
                                class="p-0 btn likeBtn"
                                :select-value="false">
                                {{ $t('message.generic.selectField.no') }}
                              </coozzy-form-radio>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="sendToBriefbutler"
                        class="row mb-3">
                        <div class="col-12">
                          <label for="question2">{{ $t('message.briefButler.modal.howSendDoc') }} *
                          </label>
                          <div class="col-sm-12 col-md-12 mb-2">
                            <template
                              v-for="(item, itemIndex) in profiles">
                              <div
                                :key="`item_${itemIndex}`"
                                class="col-6 pl-0 pr-0">
                                <coozzy-form-radio
                                  v-model="selectedProfile"
                                  :default-model="selectedProfile"
                                  :select-value="item.briefbutlerId"
                                  :name="item.briefbutlerId"
                                  :state="$v.selectedProfile.$dirty && $v.selectedProfile.$error ? false : null"
                                  class="mt-2">
                                  {{ item.description }}
                                </coozzy-form-radio>
                              </div>
                            </template>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-6">
                      <document-preview-table
                        v-if="contractTemplateSelected.length > 0 && activeTab >= 1"
                        :key="randomKey"
                        :list-templates="contractTemplate"
                        :selected-template="contractTemplateSelected"
                        :list-tenancies="listTenancies"
                        :list-objects="listObjects"
                        :contacts="contacts"
                        :merge-documents="mergeDocuments"
                        :source="source"
                        :title="title"
                        :description="description"
                        :sorting-type="sortingType"
                        :show-in-portal="showInPortal" />
                    </div>
                  </div>
                </div>
              </div>
            </tab-content>
          </template>
          <template
            #footer="props">
            <template v-if="!renderContractLoading">
              <div class="wizard-footer-left">
                <wizard-button
                  :style="props.fillButtonStyle"
                  class="mr-2"
                  @click.native="$router.back()">
                  {{ $t('message.generic.cancel') }}
                </wizard-button>
                <wizard-button
                  v-if="props.activeTabIndex > 0"
                  :style="props.fillButtonStyle"
                  @click.native="backClicked(props)">
                  {{ $t('message.generic.back') }}
                </wizard-button>
              </div>
              <div class="wizard-footer-right">
                <template v-if="!props.isLastStep">
                  <wizard-button
                    v-if="!props.isLastStep"
                    :style="props.fillButtonStyle"
                    class="wizard-footer-right"
                    @click.native="nextStep(props)">
                    <template>
                      {{ $t('message.generic.next') }}
                    </template>
                  </wizard-button>
                </template>
                <wizard-button
                  v-else
                  :style="props.fillButtonStyle"
                  class="wizard-footer-right"
                  @click.native="renderContract">
                  {{ $t('message.generic.create') }}
                </wizard-button>
              </div>
            </template>
          </template>
        </form-wizard>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import TemplateTable from '@/settings/components/TemplateTable'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import ObjectApi from '@/misc/apis/ObjectApi'
import MediaApi from '@/misc/apis/MediaApi'
import ContactApi from '@/misc/apis/ContactApi'
import { tables } from '@/mixins/tables'
import { obj } from '@/mixins/object'
import { routeChecks } from '@/mixins/routeChecks'
import { saveAs } from 'file-saver'
import CoozzyFormRadio from '@/framework/components/form/radio/CoozzyFormRadio.vue'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import { mapState } from 'vuex'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import { required } from 'vuelidate/lib/validators'
import { validation } from '@/mixins/validation'
import BriefButlerApi from '@/misc/apis/BriefButlerApi'
import PortalApi from '@/misc/apis/PortalApi'
import DocumentPreviewTable from '@/addTenancy/documentPreviewTable.vue'
import CoozzyInfoCircleIcon from '@/framework/components/icons/CoozzyInfoCircleIcon.vue'
import Editor from '@tinymce/tinymce-vue'
import { user } from '@/mixins/user'
import { countUniqueSerialLetterEntities, filterUniqueSerialLetterEntities } from '@/misc/utils/serialLetterUtils'

export default {
  name: 'SerialLetterProcessView',
  components: {
    Editor,
    CoozzyInfoCircleIcon,
    DocumentPreviewTable,
    CoozzyFormInput,
    CoozzyFormSelect,
    CoozzyFormRadio,
    CoozzySpinner,
    TemplateTable
  },
  mixins: [tables, routeChecks, obj, validation, user],
  beforeRouteLeave(to, from, next) {
    if (to.fullPath !== from.fullPath) {
      localStorage.removeItem(this.uuid)
      next()
    } else {
      next(false)
    }
  },
  props: {
    source: {
      type: String,
      default: 'tenancy'
    },
    uuid: {
      type: [Array, String],
      default() {
        return []
      }
    },
    singleLetter: {
      type: [Boolean, String],
      default: false
    },
    previousRoute: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      randomKey: 0,
      activeTab: 0,
      isBusy: true,
      listObjects: [],
      addDocumentToContact: false,
      showInPortal: false,
      isPortalLinkEnabled: false,
      allPortalLinkEnabled: false,
      isAllPortalLinkDisable: false,
      ownerProperties: [],
      includeRoommates: false,
      mergeDocuments: false,
      contractTemplate: [],
      contacts: [],
      contractTemplateSelected: [],
      listTenancies: [],
      tenancies: [],
      objectIds: [],
      tenantObject: [],
      renderContractLoading: true,
      blobs: [],
      title: '',
      description: '',
      selectedTemplate: '',
      listOfReferenceIds: [],
      sortingType: 'RENDER_ORDER_DEFAULT',
      profiles: [],
      sendToBriefbutler: false,
      selectedProfile: null
    }
  },
  computed: {
    ...mapState('message', ['templates']),
    isSingleLetter() {
      return this.singleLetter === true || this.singleLetter === 'true'
    },
    editorApi() {
      return 'gpl'
    },
    fontSetting() {
      return this.$store.getters['user/getFontSettings']
    },
    contentStyle() {
      const defaultFontFamily = 'Arial'
      const fontFamily = this.fontSetting && this.fontSetting.family !== '' ? `${this.fontSetting.family}` : defaultFontFamily
      const fontSize = this.fontSetting && this.fontSetting.size !== '' ? this.fontSetting.size + 'pt' : '10pt'
      return `body { color: #000 !important; font-family: ${fontFamily} !important; font-size: ${fontSize};} p {margin: 0}`
    },
    fontsizeFormats() {
      let sizeOptions = []
      for (let i = 4; i <= 36; i++) {
        sizeOptions.push(`${i}pt`)
      }
      return sizeOptions.join(' ')
    },
    fontFormats() {
      const defaultFont = 'Lato=Lato, sans-serif;'
      const userFont = this.fontSetting && this.fontSetting.family !== '' ? `${this.fontSetting.family}=${this.fontSetting.family}, sans-serif;` : defaultFont
      return `${userFont}`
    },
    onlySelectedTemplate() {
      return this.contractTemplate.filter(x => this.contractTemplateSelected.includes(x.id))
    },
    sortedTemplate() {
      return this.templates.filter(x => x.type === 'TEMPLATE_TYPE_LETTER').slice().sort((a, b) => {
        if (a.name > b.name) {
          return 1
        }
        if (b.name > a.name) {
          return -1
        }
        return 0
      })
    },
    countGeneratedDocs() {
      return countUniqueSerialLetterEntities(this.listTenancies, this.source)
    },
    templateOwnersIds() {
      const listOwners = this.listObjects.length > 0 ? this.listObjects.map(obj => parseInt(obj.ownerId)) : this.listTenancies.length > 0 ? this.listTenancies.map(tenancy => parseInt(tenancy.ownerId)) : []
      return [...new Set(listOwners)]
    }
  },
  watch: {
    selectedTemplate: function (newVal) {
      if (newVal !== '') {
        const template = this.sortedTemplate.find(x => x.id === newVal)
        this.title = template.subject
        this.description = template.message
      } else {
        this.title = ''
        this.description = ''
      }
    },
    sendToBriefbutler: function (newVal) {
      if (!newVal) {
        this.selectedProfile = null
      }
    },
    activeTab(newVal) {
      if (newVal === 2) {
        for (let i = 0; i < this.onlySelectedTemplate.length; i++) {
          if (!this.onlySelectedTemplate[i].documentName) {
            this.onlySelectedTemplate[i].documentName = this.onlySelectedTemplate[i].title
          }
        }
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
        // ---- defaults / early exit
        this.addDocumentToContact = false
        this.includeRoommates = false
        this.mergeDocuments = false
        this.title = ''
        this.description = ''
        this.listTenancies = []
        this.tenantObject = []

        const raw = localStorage.getItem(this.uuid)
        const listOfReferenceIds = raw ? raw.split(',').filter(Boolean) : []
        this.listOfReferenceIds = listOfReferenceIds
        if (listOfReferenceIds.length === 0) {
          this.loading = false
          this.renderContractLoading = false
          return
        }

        // working sets to avoid O(n^2) and dupes
        const contactIdSet = new Set()
        const objectIdSet = new Set()
        const localTenancies = [] // collect→assign once (fewer reactive writes)

        // helper to safely add contact ids
        const addContacts = (ids) => { if (Array.isArray(ids)) ids.forEach(id => id && contactIdSet.add(id)) }

        // ---- branch on reference type
        try {
          const first = listOfReferenceIds[0]

          if (first.startsWith('tenancy_')) {
            const tenancyIds = [...new Set(listOfReferenceIds)]
            const { tenancies = [] } = await ObjectApi.getTenanciesByIds(tenancyIds)

            // fetch related objects in parallel (one batch)
            tenancies.forEach(t => {
              addContacts(t?.tenant?.contactIds || [])
              const oid = t?.obj?.id || t?.objectId
              if (oid) objectIdSet.add(oid)
            })

            // batch getObject and merge numericId; tolerate per-item failures
            const objectIds = [...objectIdSet]
            // const objectResp = await Promise.allSettled(objectIds.map(id => ObjectApi.getObject(id)))
            const objectResp = await ObjectApi.listObjectsByIds(objectIds)
            const idToNumeric = new Map()
            if (objectResp.objects.length > 0) {
              objectResp.objects.forEach((obj, i) => {
                const numericId = obj.value?.object?.numericId || ''
                idToNumeric.set(objectIds[i], numericId)
              })

              for (const tenancy of tenancies) {
                const oid = tenancy?.obj?.id || tenancy?.objectId
                localTenancies.push({ ...tenancy, objectNumericId: idToNumeric.get(oid) || '' })
              }
            }
          } else if (first.startsWith('condominium_')) {
            const condoIds = [...new Set(listOfReferenceIds)]
            const { condominiums = [] } = await ObjectApi.getCondominiumByIds(condoIds)

            condominiums.forEach(condominium => {
              addContacts(condominium?.owner?.contactIds || [])
              const oid = condominium?.obj?.id || condominium?.objectId
              if (oid) objectIdSet.add(oid)
            })

            const objectIds = [...objectIdSet]
            const objectResp = await ObjectApi.listObjectsByIds(objectIds)
            const idToNumeric = new Map()
            if (objectResp.objects.length > 0) {
              objectResp.objects.forEach((obj, i) => {
                const numericId = obj.value?.object?.numericId || ''
                idToNumeric.set(objectIds[i], numericId)
            })

            for (const condominium of condominiums) {
              const oid = condominium?.obj?.id || condominium?.objectId
              localTenancies.push({ ...condominium, objectNumericId: idToNumeric.get(oid) || '' })
            }
            }
          } else if (first.startsWith('obj_')) {
            const objectIds = [...new Set(listOfReferenceIds)]
            const { objects = [] } = await ObjectApi.listObjectsByIds(objectIds)
            this.listObjects = objects
            const loadedObjectIds = objects.map(o => o.id)

            if (this.source === 'tenancy') {
              const { tenancies = [] } = await ObjectApi.listCurrentByObjectIds(loadedObjectIds)
              for (const tenancy of tenancies) {
                objectIdSet.add(tenancy.objectId)
                addContacts(tenancy?.tenant?.contactIds || [])
                localTenancies.push(tenancy)
              }
            } else if (this.source === 'condominium') {
              const { condominiums = [] } = await ObjectApi.listCurrentCondominiumsByObjectIds(loadedObjectIds)
              for (const condominium of condominiums) {
                objectIdSet.add(condominium.objectId)
                addContacts(condominium?.owner?.contactIds || [])
                localTenancies.push(condominium)
              }
            }
          } else if (first.startsWith('contact_') && this.source === 'contact') {
            listOfReferenceIds.forEach(id => contactIdSet.add(id))
          }

          // ---- assign the collected tenancies once
          if (localTenancies.length) this.listTenancies = localTenancies

          // ---- parallel building/property/portal lookups (only if we have object ids)
          const objectIdsForBuildings = [...objectIdSet]
          if (objectIdsForBuildings.length) {
            try {
              const { buildings = [] } = await ObjectApi.getBuildingByObjectIds(objectIdsForBuildings)
              const buildingIds = buildings.map(b => b.id).filter(Boolean)

              if (buildingIds.length) {
                const { properties = [] } = await ObjectApi.getPropertiesByBuildingIds(buildingIds)
                const ownerIds = [...new Set(properties.map(p => p.ownerId).filter(Boolean))]
                if (ownerIds.length) {
                  // one Promise.all, not inside forEach
                  const portalStatuses = await Promise.all(ownerIds.map(PortalApi.getPortalStatus))
                  this.ownerProperties = ownerIds
                  this.allPortalLinkEnabled = portalStatuses.every(s => s.enabled === true)
                  this.isPortalLinkEnabled = portalStatuses.some(s => s.enabled === true)
                  this.isAllPortalLinkDisable = portalStatuses.every(s => s.enabled === false)
                }
              }
            } catch (e) {
              console.error(e)
            }
          }

          // ---- load contacts
          const contactIds = [...contactIdSet]
          if (contactIds.length) {
            await this.loadContacts(contactIds)
          }
        } catch (e) {
          console.error(e)
        } finally {
          this.renderContractLoading = false
        }

        // ---- load settings in parallel with everything else (don’t block UI)
        try {
          const res = await BriefButlerApi.loadSettings(this.$store.getters['user/getAccountId'])
          this.profiles = res.profiles
        } catch (e) {
          console.error(e)
          Vue.toasted.show('Die BriefButler-Einstellungen konnten nicht geladen werden', { type: 'error' })
        } finally {
          this.loading = false
        }
    },
    handleTabChange(prevIndex, nextIndex) {
      this.activeTab = nextIndex
    },
    loadContacts(contactIds) {
      if (contactIds.length === 0) {
        return Promise.resolve()
      }
      return ContactApi.contactResolve(contactIds)
        .then(response => {
          const contactsById = new Map((response.persons.concat(response.companies)).map(contact => [contact.id, contact]))
          this.contacts = contactIds
            .map(contactId => contactsById.get(contactId))
            .filter(contact => contact && (this.isSingleLetter || !contact.dateOfDeath))

          const aliveIds = new Set(this.contacts.map(c => c.id))
          if (this.listTenancies.length > 0) {
            const firstId = this.listTenancies[0].id || this.listTenancies[0].objectID || ''
            if (firstId.startsWith('condominium_')) {
              this.listTenancies = this.listTenancies.filter(el => el.owner?.contactIds?.some(id => aliveIds.has(id)))
            } else {
              this.listTenancies = this.listTenancies.filter(el => el.tenant?.contactIds?.some(id => aliveIds.has(id)))
            }
          }
        })
    },
    nextStep(props) {
      props.nextTab()
      this.scrollToTop()
    },
    scrollToTop() {
      this.$nextTick(() => {
        const domRect = this.$el.querySelector('#wizard')
        domRect.scrollIntoView(true)
      })
    },
    itemSelected(ids, contracts) {
      this.contractTemplateSelected = ids
      this.contractTemplate = contracts
    },
    getSortedContactIdsForRender() {
      const contacts = Array.isArray(this.contacts) ? [...this.contacts] : []
      const toId = (contact) => contact?.id || contact?.objectID || ''
      const compareText = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })

      // Only "Propbase standard" is sorted in frontend; all other modes are handled by backend.
      if (this.sortingType === 'RENDER_ORDER_DEFAULT') {
        contacts.sort((a, b) => {
          const byName = compareText((a?.name || '').toString(), (b?.name || '').toString())
          if (byName !== 0) return byName
          const byEmail = compareText((a?.email || '').toString(), (b?.email || '').toString())
          if (byEmail !== 0) return byEmail
          return compareText(toId(a).toString(), toId(b).toString())
        })
      }

      return contacts.map(contact => toId(contact)).filter(Boolean)
    },
    contractsLoaded(contracts) {
      this.contractTemplate = contracts
    },
    redirectToPreviousPage() {
      this.$router.push(this.previousRoute)
    },
    redirectToDetailPage(object) {
      if (object !== null) {
        let routerHref = ''
        if (this.isOwnerModule) {
          routerHref = this.$router.resolve({
            name: 'OwnerBuildingDetailsView',
            params: { id: object.buildingId },
            query: {
              view: 'objects',
              elementSelected: object.objectID || object.id
            }
          })
        } else if (this.isAssetModule) {
          routerHref = this.$router.resolve({
            name: 'AssetBuildingDetailsView',
            params: { id: object.buildingId },
            query: {
              view: 'objects',
              elementSelected: object.objectID || object.id
            }
          })
        } else if (this.isAccountingModule) {
          routerHref = this.$router.resolve({
            name: 'AccountingBuildingDetailsView',
            params: { id: object.buildingId },
            query: {
              view: 'objects',
              elementSelected: object.objectID || object.id
            }
          })
        } else {
          routerHref = this.$router.resolve({
            name: 'AdminBuildingDetailsView',
            params: { id: object.buildingId },
            query: {
              view: 'objects',
              elementSelected: object.objectID || object.id
            }
          })
        }
        window.open(routerHref.href, '_blank')
      }
    },
    async renderContract() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.scrollToError()
        return
      }
      this.renderContractLoading = true
      let countResult = 0
      const array = []
      const promises = []
      const listTemplatePdf = []
      const entitiesToProcess = this.listTenancies.length > 0
        ? filterUniqueSerialLetterEntities(this.listTenancies, this.source)
        : []
      // const vacancies = this.listOfReferenceIds.filter(id => !this.listTenancies.some(tenancy => tenancy.id === id) && id.startsWith('tenancy_'))
      if (this.mergeDocuments) {
        for (let index = 0; index < this.contractTemplateSelected.length; index++) {
          const signatories = []
          const contract = this.contractTemplate.find(x => x.id === this.contractTemplateSelected[index])
          if (contract && !contract.mediaId.includes('.pdf')) {
            array.push({
              contract: this.contractTemplateSelected[index]
            })
            if (contract && contract.firstSignature !== '') {
              signatories.push(contract.firstSignature)
            }
            if (contract && contract.secondSignature) {
              if (contract && contract.firstSignature === '') {
                signatories.push('')
              }
              signatories.push(contract.secondSignature)
            }

            if (entitiesToProcess.length > 0) {
              const id = entitiesToProcess[0].id || entitiesToProcess[0].objectID
              if (id.startsWith('condominium_')) {
                promises.push(ObjectApi.renderContractCondominiums(this.contractTemplateSelected[index], entitiesToProcess.map(condominium => condominium.id || condominium.objectID), this.title, this.description, contract.documentName, this.includeRoommates, this.selectedProfile, signatories, this.addDocumentToContact, this.showInPortal, this.sortingType, this.selectedProfile !== null))
              } else {
                promises.push(ObjectApi.renderTenanciesTemplate(this.contractTemplateSelected[index], entitiesToProcess.map(x => x.id || x.objectID), this.title, this.description, contract.documentName, signatories, this.selectedProfile, this.addDocumentToContact, this.showInPortal, this.sortingType, this.selectedProfile !== null))
              }
            } else if (this.source === 'contact') {
              if (this.contacts.length) {
                promises.push(ObjectApi.renderContractContacts(this.contractTemplateSelected[index], this.getSortedContactIdsForRender(), this.title, this.description, contract.documentName, this.selectedProfile, signatories, this.addDocumentToContact, this.showInPortal, this.sortingType, this.selectedProfile !== null))
              }
            // } else if (vacancies.length > 0) {
            //   promises.push(ObjectApi.renderTenanciesTemplate(this.contractTemplateSelected[index], vacancies, this.title, this.description, signatories, this.addDocumentToContact))
            }
          } else if (contract) {
            listTemplatePdf.push(contract.mediaId)
          }
        }
      } else {
        for (let index = 0; index < this.contractTemplateSelected.length; index++) {
          const signatories = []
          const contract = this.contractTemplate.find(x => x.id === this.contractTemplateSelected[index])
          if (contract && !contract.mediaId.includes('.pdf')) {
            if (contract && contract.firstSignature !== '') {
              signatories.push(contract.firstSignature)
            }
            if (contract && contract.secondSignature) {
              if (contract && contract.firstSignature === '') {
                signatories.push('')
              }
              signatories.push(contract.secondSignature)
            }
            if (this.source === 'contact') {
              this.contacts.forEach(element => {
                array.push({
                  contract: this.contractTemplateSelected[index],
                  contactId: element.id || element.objectID
                })
                promises.push(ObjectApi.renderContractContact(this.contractTemplateSelected[index], element.id || element.objectID, this.addDocumentToContact, this.showInPortal, this.title, this.description, contract.documentName, this.selectedProfile, signatories, this.selectedProfile !== null))
              })
            } else if (entitiesToProcess.length > 0) {
              const id = entitiesToProcess[0].id || entitiesToProcess[0].objectID
              entitiesToProcess.forEach(element => {
                if (id.startsWith('condominium_')) {
                  array.push({
                    contract: this.contractTemplateSelected[index],
                    condominiumId: element.id || element.objectID
                  })
                  promises.push(ObjectApi.renderContractCondominium(this.contractTemplateSelected[index], element.id || element.objectID, this.addDocumentToContact, this.showInPortal, this.title, this.description, contract.documentName, this.includeRoommates, this.selectedProfile, signatories, this.selectedProfile !== null))
                } else {
                  array.push({
                    contract: this.contractTemplateSelected[index],
                    tenancyId: element.id || element.objectID
                  })
                  promises.push(ObjectApi.RenderTenancyTemplate(this.contractTemplateSelected[index], element.id || element.objectID, this.addDocumentToContact, this.showInPortal, this.title, this.description, contract.documentName, this.selectedProfile, signatories, false, this.selectedProfile !== null))
                }
              })
            }
          } else if (contract) {
            listTemplatePdf.push(contract.mediaId)
          }
        }
      }
      if (listTemplatePdf.length > 0) {
          MediaApi.getListMedia(listTemplatePdf).then(response => {
            for (const media of response.media) {
              saveAs(media.url, media.filename)
            }
          })
      }
      return Promise.all(promises)
        .then((response) => {
          if (this.selectedProfile === null) {
            countResult = response.length
            const renderId = []
            response.forEach((element, index) => {
              if (countResult > 10) {
                const contract = this.contractTemplate.find(x => x.id === array[index].contract)
                const contractName = contract.documentName || contract.title
                let nameBlob
                if (this.mergeDocuments) {
                  nameBlob = contractName
                } else {
                  if (this.source === 'contact') {
                    const currentContact = this.contacts.find(x => x.id === array[index].contactId || x.objectID === array[index].contactId)
                    const tenantName = currentContact && 'name' in currentContact && currentContact.name ? currentContact.name + '_' + currentContact.numericId : ''
                    nameBlob = contractName + '_' + tenantName
                  } else if (this.source === 'condominium') {
                    const currentCondo = this.listTenancies.find(x => x.id === array[index].condominiumId || x.objectID === array[index].condominiumId)
                    const tenantName = currentCondo && 'name' in currentCondo && currentCondo.name
                      ? currentCondo.name
                      : this.contacts.length > 0
                        ? this.contacts.filter(x => currentCondo.owner.contactIds.includes(x.id)).map(contact => contact.firstName && contact.lastName ? contact.firstName + ' ' + contact.lastName : contact.name).toString().replaceAll(',', '_')
                        : currentCondo.condominiumOwners && currentCondo.condominiumOwners.length > 0
                          ? currentCondo.condominiumOwners[0].name
                          : this.condominiumObject.length > 0
                            ? this.condominiumObject.find(x => currentCondo.tenant.contactIds.includes(x.contactId)).map(x => x.name).toString().replaceAll(',', '_')
                            : ''
                    const numberObject = currentCondo.numericId ? currentCondo.numericId : currentCondo.objectNumericId
                    nameBlob = contractName + '_' + tenantName + (numberObject ? '_' + numberObject : '')
                  } else {
                    const currentTenancy = this.listTenancies.find(x => x.id === array[index].tenancyId || x.objectID === array[index].tenancyId)
                    const tenantName = currentTenancy && 'name' in currentTenancy && currentTenancy.name
                      ? currentTenancy.name
                      : this.tenantObject.length > 0
                        ? this.tenantObject.find(x => currentTenancy?.tenant.contactIds.includes(x.contactId)).map(x => x.name).toString().replaceAll(',', '_')
                        : this.contacts && this.contacts.length > 0
                          ? this.contacts.filter(x => currentTenancy.tenant.contactIds.includes(x.id)).map(contact => contact.firstName && contact.lastName ? contact.firstName + ' ' + contact.lastName : contact.name).toString().replaceAll(',', '_')
                          : currentTenancy?.tenants.map(x => x.name).toString().replaceAll(',', '_')
                    const numberObject = currentTenancy?.numericId ? currentTenancy?.numericId : currentTenancy?.objectNumericId
                    nameBlob = contractName + '_' + tenantName + (numberObject ? '_' + numberObject : '')
                  }
                }
                const item = {
                  renderId: element.renderId + '_' + nameBlob + '-/-' + contract.enforcePdf,
                  contract: contract
                }
                renderId.push(item)
              } else {
                const contract = this.contractTemplate.find(x => x.id === array[index].contract)
                const contractName = contract.documentName || contract.title
                let downloadName = ''
                if (this.mergeDocuments) {
                  downloadName = contractName
                } else {
                  if (this.source === 'contact') {
                    const currentContact = this.contacts.find(x => x.id === array[index].contactId || x.objectID === array[index].contactId)
                    const tenantName = currentContact && 'name' in currentContact && currentContact.name ? currentContact.name + '_' + currentContact.numericId : ''
                    downloadName = contractName + '_' + tenantName
                  } else {
                    if (this.source === 'condominium') {
                      const currentCondo = this.listTenancies.find(x => x.id === array[index].condominiumId || x.objectID === array[index].condominiumId)
                      const tenantName = currentCondo && 'name' in currentCondo && currentCondo.name
                        ? currentCondo.name
                        : this.contacts.length > 0
                          ? this.contacts.filter(x => currentCondo.owner.contactIds.includes(x.id)).map(contact => contact.firstName && contact.lastName ? contact.firstName + ' ' + contact.lastName : contact.name).toString().replaceAll(',', '_')
                          : currentCondo.condominiumOwners && currentCondo.condominiumOwners.length > 0
                            ? currentCondo.condominiumOwners[0].name
                            : this.condominiumObject.length > 0
                              ? this.condominiumObject.find(x => currentCondo.tenant.contactIds.includes(x.contactId)).map(x => x.name).toString().replaceAll(',', '_')
                              : ''

                      const numberObject = currentCondo.numericId ? currentCondo.numericId : currentCondo.objectNumericId
                      downloadName = contractName + '_' + tenantName + (numberObject ? '_' + numberObject : '')
                    } else {
                      const currentTenancy = this.listTenancies.find(x => x.id === array[index].tenancyId || x.objectID === array[index].tenancyId)
                      const tenantName = currentTenancy && 'name' in currentTenancy && currentTenancy.name
                        ? currentTenancy.name
                        : this.tenantObject.length > 0
                          ? this.tenantObject.find(x => currentTenancy?.tenant.contactIds.includes(x.contactId)).map(x => x.name).toString().replaceAll(',', '_')
                          : this.contacts && this.contacts.length > 0 && this.contacts.filter(x => currentTenancy?.tenant.contactIds.includes(x.id)).length > 0
                            ? this.contacts.filter(x => currentTenancy?.tenant.contactIds.includes(x.id))?.map(contact => contact.firstName && contact.lastName ? contact.firstName + ' ' + contact.lastName : contact.name).toString().replaceAll(',', '_')
                            : currentTenancy?.tenants ? currentTenancy?.tenants?.map(x => x.name).toString().replaceAll(',', '_') : ''
                      const numberObject = currentTenancy?.numericId ? currentTenancy?.numericId : currentTenancy?.objectNumericId ? currentTenancy?.objectNumericId : this.listObjects.find(x => x.id === currentTenancy?.objectId) ? this.listObjects.find(x => x.id === currentTenancy?.objectId).numericId : null
                      downloadName = contractName + '_' + tenantName + (numberObject ? '_' + numberObject : '')
                    }
                  }
                }
                const item = {
                  renderId: element.renderId + '_' + downloadName + '-/-' + contract.enforcePdf,
                  contract: contract
                }
                renderId.push(item)
              }
              // Replace any stale pending render IDs so leftover downloads cannot pad this run.
              localStorage.setItem('renderId', JSON.stringify(renderId))
              Vue.toasted.show(this.$t('message.successMessages.serialLetterCreated'), { type: 'success' })
            })
          }
        })
        .catch(e => {
          console.log(e)
          if (e.response?.data?.message === 'Lack of brief tag') {
            Vue.toasted.show(this.$t('message.savingErrors.lackOfBriefTag'), { type: 'error' })
          } else if (e.response?.data?.message === 'Lack of data loop') {
            Vue.toasted.show(this.$t('message.savingErrors.lackOfDataLoop'), { type: 'error' })
          } else {
            Vue.toasted.show(this.$t('message.savingErrors.renderingContractError'), { type: 'error' })
          }
          this.loading = false
        })
        .finally(() => {
          this.renderContractLoading = false
          this.mergeDocuments = false
          this.selectedProfile = null
          this.title = ''
          this.description = ''
          localStorage.removeItem(this.uuid)
          this.redirectToPreviousPage()
        })
    },
    checkDocumentName(renderId) {
      const renderIdsWithData = [renderId]
      const renderContractName = (renderIdsWithData.find(w => w.startsWith(renderId)).substring(renderIdsWithData.find(w => w.startsWith(renderId)).indexOf('_') + 1)).split('-/-')[0]
      const renderContractEnforcePdf = (renderIdsWithData.find(w => w.startsWith(renderId)).substring(renderIdsWithData.find(w => w.startsWith(renderId)).indexOf('_') + 1)).split('-/-')[1]
      return { renderContractName, renderContractEnforcePdf }
    },
    backClicked(props) {
      props.prevTab()
      this.scrollToTop()
    },
    getFilteredTenancies(objectId) {
      return this.tenancies.filter(ten => {
        return ten.objectId === objectId
      })
    },
    getCurrentTenancy(tenancies) {
      // We got an object from our backend
      const startOfDayTimestamp = this.getStartOfDayTimestamp()

      return tenancies
        .sort((a, b) => new Date(this.$options.filters.objectToDateInput(a.startingAt)).getTime() / 1000 > new Date(this.$options.filters.objectToDateInput(b.startingAt)).getTime() / 1000 ? -1 : 1)
        .find(t => t.startingAt && new Date(this.$options.filters.objectToDateInput(t.startingAt)).getTime() / 1000 <= startOfDayTimestamp && (!t.endingAt || (new Date(this.$options.filters.objectToDateInput(t.endingAt)).getTime() / 1000 < 0 || new Date(this.$options.filters.objectToDateInput(t.endingAt)).getTime() / 1000 >= startOfDayTimestamp)))
    },
    getCurrentCondominium(condominiums) {
      // We got an object from our backend
      const startOfDayTimestamp = this.getStartOfDayTimestamp()
      if (condominiums.length > 0) {
        return condominiums
          .sort((a, b) => new Date(this.$options.filters.objectToDateInput(a.startingAt)).getTime() / 1000 > new Date(this.$options.filters.objectToDateInput(b.startingAt)).getTime() / 1000 ? -1 : 1)
          .find(t => t.startingAt && new Date(this.$options.filters.objectToDateInput(t.startingAt)).getTime() / 1000 <= startOfDayTimestamp && (!t.endingAt || (new Date(this.$options.filters.objectToDateInput(t.endingAt)).getTime() / 1000 < 0 || new Date(this.$options.filters.objectToDateInput(t.endingAt)).getTime() / 1000 >= startOfDayTimestamp)))
      }
      return null
    },
    getListTenancies() {
      if (this.objectIds.length) {
        ObjectApi.listCurrentByObjectIds(this.objectIds.map(obj => obj)).then(responseTenancy => {
          const promises = []
          for (let index = 0; index < responseTenancy.tenancies.length; index++) {
            promises.push(ObjectApi.getObject(responseTenancy.tenancies[index].objectId))
          }
          Promise.all(promises)
            .then((responseObject) => {
              this.listTenancies = []
              for (let index = 0; index < responseTenancy.tenancies.length; index++) {
                Object.assign(responseTenancy.tenancies[index], { objectNumericId: responseObject[index].object?.numericId ? responseObject[index].object.numericId : '' })
                this.listTenancies.push(responseTenancy.tenancies[index])
              }
              this.renderContractLoading = false
            })
            .catch(e => {
              console.log(e)
              this.renderContractLoading = false
            })
        })
      }
    }
  },
  validations() {
    if (this.sendToBriefbutler) {
      return {
        selectedProfile: {
          required
        }
      }
    }

    return {}
  }
}
</script>

<style lang="scss" scoped>
.container-preview-img {
  max-height: 40rem;
  overflow: hidden;
  padding: 60px;
}

.step3 {
  min-height: 40vh;
}
.title-center {
  align-content: center;
}
</style>
